<template>
  <v-dialog
    :value="csat_survey"
    width="550"
    persistent
    content-class="custom-dialog-content"
    overlay-class="custom-dialog-overlay"
    :z-index="9999"
    attach
  >
    <v-card class="index-page pa-4 pa-sm-8">
      <v-row no-gutters>
        <v-col cols="12" class="text-center mb-4">
          <span class="text-title">ประเมินความพึงพอใจ</span>
        </v-col>
        <v-col cols="12">
          <v-img :src="surveyImage" height="260px" contain />
        </v-col>
        <v-col cols="12" class="text-center mt-8 mb-4">
           <span>
            แบบประเมินความพึงพอใจในการใช้งาน {{ themes?.description }}
            เพื่อนำข้อมูลที่ได้ไปใช้ในการพัฒนาระบบให้ตรงต่อความต้องการมากยิ่งขึ้น
            สามารถติดต่อขอข้อมูลเพิ่มเติมได้ที่
          </span>
        </v-col>
        <v-col cols="12" class="text-center">
          <span
            >โทรศัพท์ : 062-601-6090 (คุณแสน) หรือ 065-508-3364 (คุณวา)</span
          >
        </v-col>
        <v-col cols="12" class="text-center">
          <span>
            อีเมล : <span class="text-email">nockkc@inet.co.th</span> ,
            <span class="text-email">onebox@inet.co.th</span>
          </span>
        </v-col>
        <v-col cols="12" class="mt-4">
          <v-row no-gutters justify="center">
            <v-col cols="auto" class="text-center mr-2">
              <v-btn
                color="default_button_primary"
                class="btn-submit"
                outlined
                @click="closeDialog"
              >
                ประเมินภายหลัง
              </v-btn>
            </v-col>
            <v-col cols="auto" class="text-center ml-2">
              <v-btn
                color="default_button_primary"
                class="btn-submit"
                dark
                @click="goSurvey"
              >
                เริ่มการประเมิน
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DialogSurveyComponents",
  props: {
    csat_survey: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      business_id: localStorage.getItem("business_id"),
      access_token: localStorage.getItem("token"),
      account_id: localStorage.getItem("id_user"),
      theme: process.env.VUE_APP_USE_THEME,
    };
  },
  computed: {
    ...mapGetters({
      shared_token: "shared_token",
      csat_data: "csat_data",
      themes: "themes",
    }),
    surveyImage() {
      return process.env.VUE_APP_USE_THEME === "SPU_ADMIN"
        ? require("@/assets/survey 1_0_SPU.png")
        : require("@/assets/survey 1_0.png");
    },
  },
  created() {},
  methods: {
    updateDialog(value) {
      this.$store.commit("SET_CSAT_SURVEY", value);
    },
    closeDialog() {
      this.$store.commit("SET_CSAT_SURVEY", false);
    },
    async goSurvey() {
      try {
        if (!this.access_token) {
          console.error("Failed to retrieve shared_token");
          return;
        }
        let site = this.theme;
        const refcode = localStorage.getItem("refcode") || "-";
        if (refcode == "moph") {
          site = "MOPH_ADMIN";
        }

        let response = await this.$store.dispatch("shareTokenToCsatSurvey", {
          biz_id: this.business_id,
          site: site,
        });
        let survey_token = response.survey_token;
        const redirectUrl = encodeURIComponent(
          `${process.env.VUE_APP_REDIRECT_AFTER_LOGOUT}/surveyRef?token=${this.access_token}&csat_token=${survey_token}&path=business_profile&business_id=${this.business_id}`
        );

        const surveyUrl = `${this.csat_data.url}?shared_token=&account_id=${this.account_id}&biz_id=${this.csat_data.business_id}&redirect_url=${redirectUrl}&service_id=${this.csat_data.service_id}&role=user`;
        this.closeDialog();
        window.location.href = surveyUrl;
      } catch (error) {
        console.error("Error fetching survey token:", error);
      }
    },
  },
};
</script>

<style scoped>
.index-page {
  border-radius: 18px;
  font-family: Noto Sans Thai !important;
}
.btn-submit {
  border-radius: 16px;
  background-color: var(--v-theme_primary) !important;
}
.text-email {
  color: var(--v-default_button_primary-base);
}
.text-title {
  color: #333333;
  font-size: 20px;
  line-height: 30px;
  font-weight: 700;
}
/* Global CSS - วางไว้ในไฟล์ global CSS หรือ App.vue */

/* วิธีที่ 1: Override Vuetify 2 Dialog Classes */
.v-dialog {
  z-index: 9999 !important;
}

.v-overlay {
  z-index: 9998 !important;
}

.v-overlay__scrim {
  z-index: 9998 !important;
}

/* วิธีที่ 2: Target specific dialog content */
.custom-dialog-content {
  z-index: 9999 !important;
  position: relative !important;
}

.custom-dialog-overlay {
  z-index: 9998 !important;
  position: fixed !important;
}

/* วิธีที่ 3: Force all dialog-related elements */
.v-dialog__content {
  z-index: 9999 !important;
}

.v-dialog__container {
  z-index: 9999 !important;
}

/* วิธีที่ 4: Specific to your component */
.v-application .v-dialog {
  z-index: 9999 !important;
}

.v-application .v-overlay {
  z-index: 9998 !important;
}

/* วิธีที่ 5: Force override ทุกอย่างที่เกี่ยวกับ dialog */
.v-dialog--active {
  z-index: 9999 !important;
}

.v-dialog--persistent {
  z-index: 9999 !important;
}

div[role="dialog"] {
  z-index: 9999 !important;
}
</style>
